'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { ALL_NETWORKS } from 'AdsUI/lib/Constants';
import CampaignsPerformanceWells from 'AdsUI/components/CampaignsPerformanceWells';

const AllCampaignsPerformanceWells = ({
  campaignData,
  campaignDataRS
}) => {
  const funnel = campaignData.aggregateFunnel;
  return /*#__PURE__*/_jsx(CampaignsPerformanceWells, {
    data: funnel,
    isLoaded: campaignDataRS.fetchedSuccessfully(),
    network: ALL_NETWORKS,
    dashboard: true
  });
};

export default AllCampaignsPerformanceWells;